/**
 * Persistencia de la sesión en el cliente. Guarda tokens + usuario en
 * localStorage para sobrevivir recargas. Es la única fuente de verdad de los
 * tokens que usa el cliente HTTP y el AuthContext.
 */
import type { SesionAuth, Tokens, Usuario } from "./types.js";

const K_TOKENS = "vc.tokens";
const K_USER = "vc.user";

function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function loadTokens(): Tokens | null {
  return safeParse<Tokens>(localStorage.getItem(K_TOKENS));
}

export function loadUser(): Usuario | null {
  return safeParse<Usuario>(localStorage.getItem(K_USER));
}

export function saveSession(sesion: SesionAuth): void {
  localStorage.setItem(K_TOKENS, JSON.stringify(sesion.tokens));
  localStorage.setItem(K_USER, JSON.stringify(sesion.usuario));
}

export function saveTokens(tokens: Tokens): void {
  localStorage.setItem(K_TOKENS, JSON.stringify(tokens));
}

export function clearSession(): void {
  localStorage.removeItem(K_TOKENS);
  localStorage.removeItem(K_USER);
}
